<!-- アクチュエータ原点リセット -->
<b-modal v-model="modal_requirement_105" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <!-- ヘッダー -->
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <!-- 文言表示 -->
  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <div class="w-100">
          <cstm-table class="data-table" v-if="showTable" :items="bodyItems" :columns="tableColumns" useStripeStyle
            hasTabs type="simple" />
          <div class="box-margin-right work-support-message">
            {{ workSupportMessage }}
          </div>
        </div>
      </div>
    </b-overlay>
  </template>

  <!-- フッダー -->
  <template v-slot:footer>
    <div class="w-100 text-center">
      <b-button v-if="phase === 'start'" size="sm" variant="outline-primary" @click="closeWizard" class="mx-2"
        :disabled="isLoading">
        {{ $t('message.common_button_cancel') }}
      </b-button>
      <b-button v-if="showButtonOk" size="sm" variant="primary" @click="onOkClicked" class="mx-2" :disabled="isLoading">
        {{ $t('message.common_button_ok') }}
      </b-button>
      <b-button v-if="phase === 'start'" size="sm" variant="primary" @click="onRunClicked" class="mx-2"
        :disabled="isLoading">
        {{ $t('individual.button_execution') }}
      </b-button>
      <b-button v-if="phase === 'executeFailed'" size="sm" variant="primary" @click="onStopClicked" class="mx-2"
        :disabled="isLoading">
        {{ $t('individual.common_button_stop') }}
      </b-button>
    </div>
  </template>
</b-modal>